(function () {
  'use strict';
  var doc = document;

  function ready(fn) {
    if (doc.readyState !== 'loading') fn(); else doc.addEventListener('DOMContentLoaded', fn);
  }

  /* Dates d'arrivee : aujourd'hui + from / to jours calendaires, au format de la langue de la page. */
  function delivery() {
    var box = doc.querySelector('[data-abn-fp-delivery]');
    if (!box) return;
    var from = parseInt(box.getAttribute('data-from'), 10);
    var to = parseInt(box.getAttribute('data-to'), 10);
    var tpl = box.getAttribute('data-tpl') || '';
    if (!from || !to || !tpl) return;
    var lang = (doc.documentElement.lang || 'en').replace('_', '-');
    var fmt;
    try {
      fmt = new Intl.DateTimeFormat(lang, { weekday: 'short', month: 'short', day: 'numeric' });
    } catch (e) {
      fmt = new Intl.DateTimeFormat('en', { weekday: 'short', month: 'short', day: 'numeric' });
    }
    var now = new Date();
    var a = new Date(now.getFullYear(), now.getMonth(), now.getDate() + from);
    var b = new Date(now.getFullYear(), now.getMonth(), now.getDate() + to);
    var target = box.querySelector('[data-abn-fp-delivery-text]');
    if (!target) return;
    target.textContent = tpl.replace('{a}', fmt.format(a)).replace('{b}', fmt.format(b)).replace(/\.{2,}$/, '.');
    box.hidden = false;
  }

  /* Option de couleurs actuellement choisie : renvoie 24, 36, 48 ou 0. */
  function selectedColors() {
    var checked = doc.querySelector('input[name="name2"]:checked');
    var txt = checked ? (checked.value || '') : '';
    if (!/\d/.test(txt)) {
      var v = doc.querySelector('.bcpo-value');
      txt = v ? v.textContent : '';
    }
    var m = /(24|36|48)/.exec(txt || '');
    return m ? parseInt(m[1], 10) : 0;
  }

  function live() {
    var box = doc.querySelector('[data-abn-fp-choose]');
    if (!box) return;
    var out = box.querySelector('[data-abn-fp-live]');
    if (!out) return;
    var n = selectedColors();
    var t = n ? box.getAttribute('data-t' + n) : '';
    var tpl = box.getAttribute('data-live') || '';
    var sz = doc.querySelector('input[name="name0"]:checked');
    var sv = sz ? (sz.value || '') : '';
    if (/50x65|60x60/.test(sv)) tpl = box.getAttribute('data-live-big') || tpl;
    else if (/30x30|30x40/.test(sv)) tpl = box.getAttribute('data-live-small') || tpl;
    var text = n && t ? tpl.replace('{n}', n).replace('{t}', t) : '';
    if (out.textContent !== text) out.textContent = text;
  }

  /* Duree ajoutee aux libelles du selecteur (app VO Product Options). */
  function labels() {
    var box = doc.querySelector('[data-abn-fp-choose]');
    if (!box) return;
    var nodes = [];
    var rs = doc.querySelectorAll('input[name="name2"]');
    for (var j = 0; j < rs.length; j++) {
      var host = rs[j].closest('li') || rs[j].parentElement;
      if (host && nodes.indexOf(host) < 0) nodes.push(host);
    }
    var vals = doc.querySelectorAll('.bcpo-value');
    for (var k = 0; k < vals.length; k++) nodes.push(vals[k]);
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.querySelector('.abn-fp-dd')) continue;
      var raw = (el.textContent || '').trim();
      var m = /^(24|36|48)\s+\S+/.exec(raw);
      if (!m || raw.length > 50 || /\d\s*"/.test(raw)) continue;
      var t = box.getAttribute('data-t' + m[1]);
      if (!t) continue;
      var s = doc.createElement('span');
      s.className = 'abn-fp-dd';
      s.textContent = ' (' + t + ')';
      el.appendChild(s);
    }
  }

  /* L'entree FAQ ajoutee rejoint le bloc FAQ existant. */
  function faq() {
    var host = doc.querySelector('.abn-faq');
    var plus = doc.querySelector('[data-abn-faq-plus]');
    if (!host || !plus) return false;
    var ps = plus.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) host.appendChild(ps[i]);
    plus.parentNode && plus.parentNode.removeChild(plus);
    return true;
  }

  /* FAQPage reconstruit depuis les questions visibles : texte identique par construction. */
  function faqSchema() {
    var host = doc.querySelector('.abn-faq');
    if (!host || doc.getElementById('abn-faq-jsonld')) return;
    var items = [];
    var ps = host.querySelectorAll('p');
    for (var i = 0; i < ps.length; i++) {
      var strong = ps[i].querySelector('strong');
      if (!strong) continue;
      var q = strong.textContent.replace(/\s+/g, ' ').trim();
      var clone = ps[i].cloneNode(true);
      var s2 = clone.querySelector('strong');
      s2.parentNode.removeChild(s2);
      var a = clone.textContent.replace(/\s+/g, ' ').trim();
      if (q && a) items.push({ '@type': 'Question', name: q, acceptedAnswer: { '@type': 'Answer', text: a } });
    }
    if (!items.length) return;
    var tag = doc.createElement('script');
    tag.type = 'application/ld+json';
    tag.id = 'abn-faq-jsonld';
    tag.text = JSON.stringify({ '@context': 'https://schema.org', '@type': 'FAQPage', mainEntity: items });
    doc.head.appendChild(tag);
  }

  ready(function () {
    delivery();
    labels();
    live();
    var moved = faq();
    if (moved || doc.querySelector('.abn-faq')) faqSchema();

    doc.addEventListener('change', function () { live(); labels(); });
    doc.addEventListener('click', function () { setTimeout(function () { live(); labels(); }, 60); });

    var root = doc.querySelector('.product__info-container') || doc.body;
    var busy = false;
    var mo = new MutationObserver(function () {
      if (busy) return;
      busy = true;
      setTimeout(function () { labels(); live(); busy = false; }, 80);
    });
    mo.observe(root, { childList: true, subtree: true, characterData: true });
    setTimeout(function () { mo.disconnect(); }, 15000);
  });
})();
